// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b71ff3bc7cf0eeb253d0f59ba28784815e4b2c9a.chunk.js";
};